/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Office Building (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgOfficeBuilding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M49 51V35a2 2 0 0 0-2-2H37a2 2 0 0 0-2 2v16m14 0H35m14 0h2m-2 0h-5m-9 0h-2m2 0h5m4 0v-5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5m4 0h-4m-1-14h1m-1 4h1m4-4h1m-1 4h1"
    />
  </svg>
);
export default SvgOfficeBuilding;
